import {Button} from "@progress/kendo-react-buttons"
import {MDBBtn, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalHeader, MDBModalTitle} from "mdbreact"
import {deleteCustomerContact, setShowDeletePopover} from "../../../containers/Customer/customerSlice"
import {RootState} from "../../../rootReducer"
import {useAppDispatch, useAppSelector} from "../../../store"

const DeleteContactModal = ({
    showDltPopover,
    customerContactId,
    customerId,
}: {
    showDltPopover: boolean
    customerContactId: number
    customerId: number
}) => {
    const dispatch = useAppDispatch()

    const contacts = useAppSelector((state: RootState) => state.containers.customer.customerContacts)

    const onClickYes = () => {
        dispatch(setShowDeletePopover(false))
        customerContactId > 0 && dispatch(deleteCustomerContact(customerId, customerContactId))
    }

    return (
        <MDBModal className="lvl-two-popup" staticBackdrop show={showDltPopover} tabIndex="-1">
            <MDBModalDialog position="modal-sm">
                <MDBModalContent>
                    <MDBModalHeader>
                        <MDBModalTitle>Delete Contacts</MDBModalTitle>
                        <MDBBtn
                            color="none"
                            className="btn-close"
                            onClick={() => dispatch(setShowDeletePopover(false))}
                        ></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                        <span>
                            Are you sure you want to delete{" "}
                            {contacts.find(contact => contact.customerContactId === customerContactId)?.firstName}?
                        </span>
                        <div className="d-flex justify-content-end mt-2">
                            <Button
                                fillMode={"flat"}
                                themeColor={"primary"}
                                style={{lineHeight: "1rem", padding: "4px 10px"}}
                                onClick={onClickYes}
                                title="Yes"
                            >
                                Yes
                            </Button>
                            <Button
                                fillMode={"flat"}
                                themeColor="primary"
                                title="No"
                                onClick={() => dispatch(setShowDeletePopover(false))}
                                style={{lineHeight: "1rem", padding: "4px 10px"}}
                                className="ms-2"
                            >
                                No
                            </Button>
                        </div>
                    </MDBModalBody>
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    )
}

export default DeleteContactModal
